<sk-modal-content
  [title]="label() | translate"
  cancelBtnText="label.Close"
  (closed)="closeWithoutResult()"
  confirmByKeypress
  (confirmed)="confirmSelection()"
  (cancelled)="closeWithoutResult()"
>
  <ng-container id="sk-modal-body">
    @if (showProjectSelector()) {
      <sk-select
        iris-entity="project"
        appendTo="body"
        [required]="true"
        [label]="'label.Project' | translate"
        [ngModel]="currentProjectId()"
        (ngModelChange)="projectChanged($event)"
      ></sk-select>
    }

    @if (showFoldersTree()) {
      <iris-dms-mat-folders-tree [multiselect]="multiselect()"></iris-dms-mat-folders-tree>
    } @else {
      <span>{{ projectInfoMessage() | translate }}</span>
    }
  </ng-container>

  <ng-container id="sk-modal-footer-buttons">
    @if (showSelectBtn()) {
      <sk-button
        data-test="modal-footer-confirm-button"
        [color]="'primary'"
        [disabled]="disableSubmit()"
        (click)="confirmSelection()"
        [label]="label() | translate"
      >
        <ng-template buttonPrefix>
          <i class="fas fa-check"></i>
        </ng-template>
      </sk-button>
    }
  </ng-container>
</sk-modal-content>
